import { call, put } from "redux-saga/effects";
import * as API from "../../../Connections/APIs/PlanView";
import * as Action from "../../Actions/PlanView/Actions";

export function* getPlanInfoSaga(action) {
  try {
    const response = yield call(
      API.getPlanInfoApi,
      action.planId,
      action.initial,
      action.isInLaunchMode,
    );
    yield put(Action.getPlanInfoSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getPlanInfoFailAction(error));
  }
}

export function* getPlanPreviewInfoSaga(action) {
  try {
    const response = yield call(
      API.getPlanPreviewInfoApi,
      action.planId,
    );
    yield put(Action.getPeviewPlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getPeviewPlanFailAction(error));
  }
}

export function* getPlanLightInfoSaga(action) {
  try {
    const response = yield call(API.getPlanLightInfoApi, action.planId);
    yield put(Action.getPlanLightInfoSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getPlanLightInfoFailAction(error));
  }
}

export function* DispatchToDriverSaga(action) {
  try {
    const response = yield call(API.DispatchToDriverApi, action.data);
    yield put(Action.DispatchToDriverSuccessAction(response.data));
  } catch (error) {
    yield put(Action.DispatchToDriverFailAction(error));
  }
}

export function* getPlanStatusSaga(action) {
  try {
    const response = yield call(API.getPlanStatusApi, action.params);
    yield put(Action.getPlanStatusSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getPlanStatusFailAction(error));
  }
}

export function* driverActivationSaga(action) {
  try {
    const response = yield call(API.driverActivationApi, action.data);
    yield put(Action.ActivationDriverSuccessAction(response.data));
  } catch (error) {
    yield put(Action.ActivationDriverFailAction(error));
  }
}

export function* getRemainCoordsSaga(action) {
  try {
    const response = yield call(API.getRemainCoordsApi, action.data);
    yield put(Action.getRemainPinCoordSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getRemainPinCoordFailAction(error));
  }
}

export function* planResetSaga(action) {
  try {
    const response = yield call(API.planResetApi, action.data);
    yield put(Action.planResetSuccessAction(response.data));
  } catch (error) {
    yield put(Action.planResetFailAction(error));
  }
}

export function* changeStatusSaga(action) {
  try {
    const response = yield call(API.ChangeMissionStatusApi, action.data);
    yield put(Action.changeMissionStatusSuccessAction(response.data));
  } catch (error) {
    yield put(Action.changeMissionStatusFailAction(error));
  }
}

export function* getMissionInfoSaga(action) {
  try {
    const response = yield call(API.getMissionInfoApi, action.data);
    yield put(Action.getMissionInfoSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getMissionInfoFailAction(error));
  }
}

export function* getNextPrevPlanSaga(action) {
  try {
    const response = yield call(API.getNextPrevPlanApi, action.data);
    yield put(Action.getNextPrevPlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getNextPrevPlanFailAction(error));
  }
}

export function* removeDriverFromPolygonSaga(action) {
  try {
    const response = yield call(API.removeDriverFromPolygonApi, action.data);
    yield put(Action.removeDriverFromPolygonSuccessAction(response.data));
  } catch (error) {
    yield put(Action.removeDriverFromPolygonFailAction(error));
  }
}

export function* removeDistributorFromPolygonSaga(action) {
  try {
    const response = yield call(
      API.removeDistributorFromPolygonApi,
      action.data
    );
    yield put(Action.removeDistributorFromPolygonSuccessAction(response.data));
  } catch (error) {
    yield put(Action.removeDistributorFromPolygonFailAction(error));
  }
}

export function* uploadLastPin(action) {
  try {
    const response = yield call(API.uploadLastPinApi, action.data);
    yield put(Action.uploadLastPinSuccessAction(response.data));
  } catch (error) {
    yield put(Action.uploadLastPinFailAction(error));
  }
}

export function* confirmLastPinSaga(action) {
  try {
    const response = yield call(API.confirmLastPinApi, action.data);
    yield put(Action.confirmLastPinSuccessAction(response.data));
  } catch (error) {
    yield put(Action.confirmLastPinFailAction(error));
  }
}

export function* getLiveTrackDriversSaga(action) {
  try {
    const response = yield call(API.getLiveTrackDriversApi, action.data);
    yield put(Action.getLiveTrackDriversSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getLiveTrackDriversFailAction(error));
  }
}

export function* changeMissionsOrderSaga(action) {
  try {
    const response = yield call(API.changeMissionsOrderApi, action.data);
    yield put(Action.changeMissionsOrderSuccessAction(response.data));
  } catch (error) {
    yield put(Action.changeMissionsOrderFailAction(error));
  }
}

export function* getDriverMissionInfoSaga(action) {
  try {
    const response = yield call(API.getDriverMissionInfoApi, action.data);
    yield put(Action.getDriverMissionInfoSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getDriverMissionInfoFailAction(error));
  }
}

export function* getDriverMissionInfoCountSaga(action) {
  try {
    const response = yield call(API.getDriverMissionInfoApi, action.data);
    yield put(Action.getDriverMissionInfoCountSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getDriverMissionInfoCountFailAction(error));
  }
}

export function* getMissionStatusExcelSaga(action) {
  try {
    const response = yield call(API.getMissionStatusExcelApi, action.data);
    yield put(Action.getMissionStatusExcelSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getMissionStatusExcelFailAction(error));
  }
}

export function* getMissionConfirmationSaga(action) {
  try {
    const response = yield call(
      API.getMissionConfirmationApi,
      action.missionId
    );
    yield put(Action.getMissionConfirmationSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getMissionConfirmationFailAction(error));
  }
}

export function* setMissionConfirmationSaga(action) {
  try {
    const response = yield call(API.setMissionConfirmationApi, action.data);
    yield put(Action.setMissionConfirmationSuccessAction(response.data));
  } catch (error) {
    yield put(Action.setMissionConfirmationFailAction(error));
  }
}

export function* searchLiveTrackSaga(action) {
  try {
    const response = yield call(API.searchLiveTrackApi, action.data);
    yield put(Action.searchInLiveTrackSuccessAction(response.data?.pinMission));
  } catch (error) {
    yield put(Action.searchInLiveTrackFailAction(error));
  }
}

export function* getActualRouteSaga(action) {
  try {
    const response = yield call(API.getActualRouteApi, action.data);
    yield put(Action.getActualRouteSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getActualRouteFailAction(error));
  }
}

export function* getChatMessagesSaga(action) {
  try {
    const response = yield call(API.getChatMessagesApi, action.data);
    yield put(Action.getChatMessagesSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getChatMessagesFailAction(error));
  }
}

export function* getCityLayerSaga(action) {
  try {
    const response = yield call(API.getCityLayerApi, action.data);
    yield put(Action.getCityLayersSuccessAction(response.data?.entity));
  } catch (error) {
    yield put(Action.getCityLayersFailAction(error));
  }
}

export function* autoAssignSaga(action) {
  try {
    const response = yield call(API.autoAssignApi, action.data);
    yield put(Action.autoDriverAssignSuccessAction(response.data));
  } catch (error) {
    yield put(Action.autoDriverAssignFailAction(error));
  }
}

export function* savePreviewSaga(action) {
  try {
    const response = yield call(API.savePreviewApi, action.data);
    yield put(Action.savePeviewPlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.savePeviewPlanFailAction(error));
  }
}

export function* getAllMissionPodSaga(action) {
  try {
    const response = yield call(API.getAllMissionPodApi, action.data);
    yield put(Action.getAllMissionPodSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getAllMissionPodFailAction(error));
  }
}

export function* getActualDeliveryMissionSaga(action) {
  try {
    const response = yield call(API.getActualDeliveryMissionApi, action.data);
    yield put(Action.getActualDeliveryMissionSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getActualDeliveryMissionFailAction(error));
  }
}

export function* autoAssignMicrohubsSaga(action) {
  try {
    const response = yield call(API.autoAssignMicrohubsApi, action.data);
    yield put(Action.autoAssignMicrohubsSuccessAction(response.data));
  } catch (error) {
    yield put(Action.autoAssignMicrohubsFailAction(error));
  }
}

export function* AddNewPinToPlanSaga(action) {
  try {
    const response = yield call(API.AddNewPinToPlanApi, action.data);
    yield put(Action.addNewPinToPlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.addNewPinToPlanFailAction(error));
  }
}

export function* EditVehicleNameSaga(action) {
  try {
    const response = yield call(API.EditVehicleNameApi, action.data);
    yield put(Action.EditVehicleNameSuccessAction(response.data, action.data));
  } catch (error) {
    yield put(Action.EditVehicleNameFailAction(error));
  }
}

export function* getLivetrackInfoSaga(action) {
  try {
    const response = yield call(API.getLivetrackInfoApi, action.data);
    yield put(Action.getLivetrackInfoSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getLivetrackInfoFailAction(error));
  }
}

export function* requestVehicleSaga(action) {
  try {
    const response = yield call(API.requestVehicleApi, action.data);
    yield put(Action.requestVehicleSuccessAction(response.data));
  } catch (error) {
    yield put(Action.requestVehicleFailAction(error));
  }
}


export function* deactivateDrivers(action) {
  try {
    const response = yield call(API.deactivateDrivers, action.data);
    yield put(Action.deactiveDriversSuccessAction(response.data));
  } catch (error) {
    yield put(Action.deactiveDriversFailAction(error));
  }
}